import { CampaignStatus } from "../types";

interface CampaignStatusBadgeProps {
  status: CampaignStatus;
}

export const CampaignStatusBadge: React.FC<CampaignStatusBadgeProps> = ({ status }) => {
  const getStatusColor = () => {
    switch (status) {
      case CampaignStatus.DRAFT:
        return "bg-gray-100 text-gray-800";
      case CampaignStatus.ACTIVE:
        return "bg-green-100 text-green-800";
      case CampaignStatus.STOPPED:
        return "bg-orange-100 text-orange-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const getStatusLabel = () => {
    switch (status) {
      case CampaignStatus.DRAFT:
        return "Draft";
      case CampaignStatus.ACTIVE:
        return "Active";
      case CampaignStatus.STOPPED:
        return "Stopped";
      default:
        return status;
    }
  };

  return (
    <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor()}`}>
      {getStatusLabel()}
    </span>
  );
};
